import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
/**
 * Store Utilities Methods
 * -----------------------------------------------------------------------------
 *
 * @namespace storeUtilities
 */

import axios from 'axios';
import Flickity from 'flickity';

var storeUtilitiesMethods = {
  data: function data() {
    return {
      shop: {},
      recentCartItem: null,
      storeUtilities: {
        ready: false,
        loginHelper: {
          settings: {},
          status: null,
          message: null,
          customerEmail: '',
          isLoginFormVisible: true
        },
        productAddons: {
          settings: {},
          products: [],
          currentProductEnabled: false,
          totalValue: null
        },
        relatedProducts: {
          settings: {},
          products: [],
          currentProductEnabled: false
        },
        cartUpsells: {
          settings: {},
          products: []
        },
        cartPromos: {
          settings: {},
          products: [],
          enablerCodes: [],
          inCartTotalValue: 0
        }
      }
    };
  },


  methods: {
    _initStoreUtilities: function _initStoreUtilities() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shopData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app.storeUtilities.ready = false;

                if (window.theme.utilitiesAppEnabled) {
                  _context.next = 4;
                  break;
                }

                app.storeUtilities.ready = true;
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return app._getShopData();

              case 6:
                shopData = _context.sent;


                if (!shopData) {
                  app.storeUtilities.ready = true;
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    _getShopData: function _getShopData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var shopData, shopSettings;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                shopData = void 0;
                shopSettings = void 0;


                shopData = app.$sessionStorage.get('shopData');

                if (shopData) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 7;
                return axios.get('/apps/store-utilities-proxy/getShopData');

              case 7:
                shopData = _context2.sent;

                app.shop = shopData.data.shop;
                shopSettings = shopData.data.settings.data;
                // pass to session storage to reduce server calls
                app.$sessionStorage.set('shopData', shopData.data);
                _context2.next = 15;
                break;

              case 13:
                app.shop = shopData.shop;
                shopSettings = shopData.settings.data;

              case 15:

                app.storeUtilities.loginHelper.settings = shopSettings.loginHelper;
                app.storeUtilities.productAddons.settings = shopSettings.productAddons;
                app.storeUtilities.relatedProducts.settings = shopSettings.relatedProducts;
                app.storeUtilities.cartPromos.settings = shopSettings.cartPromos;
                app.storeUtilities.cartUpsells.settings = shopSettings.cartUpsells;
                app.storeUtilities.ready = true;

                app._initCartUpsells();
                app._setPromosEnablerCodes();

                _context2.t0 = app.currentTemplate;
                _context2.next = _context2.t0 === 'product' ? 26 : _context2.t0 === 'cart' ? 29 : _context2.t0 === 'account' ? 31 : 32;
                break;

              case 26:
                app._initProductAddons();
                app._initRelatedProducts();
                return _context2.abrupt('break', 32);

              case 29:
                app._initCartPromos();
                return _context2.abrupt('break', 32);

              case 31:
                return _context2.abrupt('break', 32);

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2['catch'](0);

                app.storeUtilities.ready = true;
                // console.log(Object.keys(error), error.message);

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 34]]);
      }))();
    },
    _initProductAddons: function _initProductAddons() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var productAddons;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (app.storeUtilities.productAddons.settings.enabled) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.next = 4;
                return axios.get('/apps/store-utilities-proxy/getProductAddons?product_id=' + app.product.id);

              case 4:
                productAddons = _context3.sent;


                app.storeUtilities.productAddons.currentProductEnabled = productAddons.data.enabled;
                app.storeUtilities.productAddons.products = productAddons.data.products || [];
                if (app.storeUtilities.productAddons.settings.displayStyle === 'carousel') {
                  setTimeout(function () {
                    var $carousel = $('[data-flickity-product-addons]');
                    if ($carousel.length > 0) {
                      var options = $carousel.data('flickity-product-addons');
                      var flkty = new Flickity($carousel[0], options);
                    }
                  }, 100);
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    _initRelatedProducts: function _initRelatedProducts() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var relatedProducts;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (app.storeUtilities.relatedProducts.settings.enabled) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _context4.next = 4;
                return axios.get('/apps/store-utilities-proxy/getRelatedProducts?product_id=' + app.product.id);

              case 4:
                relatedProducts = _context4.sent;

                app.storeUtilities.relatedProducts.currentProductEnabled = relatedProducts.data.enabled;
                app.storeUtilities.relatedProducts.products = relatedProducts.data.products || [];

                if (app.storeUtilities.relatedProducts.settings.displayStyle === 'carousel') {
                  setTimeout(function () {
                    var $carousel = $('[data-flickity-related-products]');
                    if ($carousel.length > 0) {
                      var options = $carousel.data('flickity-related-products');
                      var flkty = new Flickity($carousel[0], options);
                    }
                  }, 100);
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    _initCartUpsells: function _initCartUpsells() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var cartUpsells, primaryUpsells, secondaryUpsells;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (app.storeUtilities.cartUpsells.settings.enabled) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                _context5.next = 4;
                return axios.get('/apps/store-utilities-proxy/getCartUpsells');

              case 4:
                cartUpsells = _context5.sent;

                app.storeUtilities.cartUpsells.products = [];

                // get all primary upsell products (primary products => they appear in any cart)
                primaryUpsells = cartUpsells.data.filter(function (x) {
                  return x.isPrimary === true && x.enabled === true;
                });


                primaryUpsells.forEach(function (item) {
                  app.storeUtilities.cartUpsells.products.push(item.data);
                });

                // get all secondary upsell products (not primary products => they have other assigned products)
                secondaryUpsells = cartUpsells.data.filter(function (x) {
                  return x.isPrimary === false && x.enabled === true;
                });


                secondaryUpsells.forEach(function (upsellItem) {
                  app.cart.items.forEach(function (cartItem) {
                    if (upsellItem.productId === cartItem.product_id.toString()) {
                      var _app$storeUtilities$c;

                      (_app$storeUtilities$c = app.storeUtilities.cartUpsells.products).push.apply(_app$storeUtilities$c, _toConsumableArray(upsellItem.products));
                    }
                  });
                });

                // remove duplicates
                app.storeUtilities.cartUpsells.products = app._removeDuplicates(app.storeUtilities.cartUpsells.products);

                // remove the products that are already in the cart
                app.cart.items.forEach(function (cartItem) {
                  var index = app.storeUtilities.cartUpsells.products.findIndex(function (x) {
                    return x.id === cartItem.product_id;
                  });

                  if (index > -1) {
                    app.storeUtilities.cartUpsells.products.splice(index, 1);
                  }
                });

                app._initUpsellCarousel();

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    _openModalCartUpsell: function _openModalCartUpsell(recentItem) {
      if (app.currentTemplate === 'cart') {
        return;
      }

      if (!app.recentCartItem) {
        app.recentCartItem = recentItem;
      }

      var $cartModal = $('[data-modal-cart]');
      $cartModal.modal('show');

      $cartModal.on('shown.bs.modal', function (e) {
        app._initUpsellCarousel();
      });

      $cartModal.on('hidden.bs.modal', function (e) {
        app.recentCartItem = null;
      });
    },
    _initUpsellCarousel: function _initUpsellCarousel() {
      if (app.storeUtilities.cartUpsells.settings.displayStyle !== 'carousel') {
        return;
      }

      var $carousel = void 0;
      var carouselOptions = void 0;
      var flkty = void 0;

      setTimeout(function () {
        $carousel = $('[data-flickity-cart-upsells]');
        carouselOptions = $carousel.data('flickity-cart-upsells');

        if (app.currentTemplate === 'cart') {
          $carousel.hide();
          flkty = new Flickity($carousel[0]);
        }

        if ($carousel.length > 0) {
          if (app.currentTemplate === 'cart') {
            flkty.destroy();
          }

          flkty = new Flickity($carousel[0], carouselOptions);

          if (app.currentTemplate === 'cart') {
            $carousel.show();
          }

          flkty.resize();
        }
      }, 100);
    },
    _initCartPromos: function _initCartPromos() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var cartPromoProducts, promosInCart, promosCartTotalValue;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (app.storeUtilities.cartPromos.settings.enabled) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _context6.next = 4;
                return axios.get('/apps/store-utilities-proxy/getCartPromos');

              case 4:
                cartPromoProducts = _context6.sent;

                cartPromoProducts.data.sort(function (a, b) {
                  return a.order - b.order;
                });
                app.storeUtilities.cartPromos.products = cartPromoProducts.data;

                // get all promos in cart
                promosInCart = app.cart.items.filter(function (x) {
                  return x.properties.promo_product === 'true';
                });
                // set new totals

                promosCartTotalValue = promosInCart.reduce(function (a, b) {
                  return +Number(a) + +Number(b.price);
                }, 0);

                app.storeUtilities.cartPromos.inCartTotalValue = promosCartTotalValue;
                app.cart.subtotal_price = app.cart.total_price;
                app.cart.total_price -= promosCartTotalValue; // set new total after subtracting the total addons value

                app.storeUtilities.cartPromos.products.forEach(function (product) {
                  app._checkPromoQualification(product);
                });

                app._checkCartForOrphanedPromos();

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    _submitLoginHelperForm: function _submitLoginHelperForm() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var formEl, formData, customerEmail, customerPassword, loginType, multipassSecret, customerData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                formEl = $('#customer_login')[0];
                formData = new FormData(formEl);
                customerEmail = encodeURIComponent(formData.get('customer[email]'));
                customerPassword = formData.get('customer[password]');
                loginType = app.storeUtilities.loginHelper.settings.type;
                multipassSecret = app.storeUtilities.loginHelper.settings.multipassSecret;


                app.isLoading = true;

                _context7.prev = 7;
                _context7.next = 10;
                return axios.get('/apps/store-utilities-proxy/getCustomerData?customer_email=' + customerEmail + '&secret=' + multipassSecret);

              case 10:
                customerData = _context7.sent;

                app.isLoading = false;
                app.storeUtilities.loginHelper.status = customerData.data.status;
                app.storeUtilities.loginHelper.message = customerData.data.message;

                if (loginType === 'default') {
                  if (customerPassword) {
                    formEl.submit();
                  } else {
                    $('#customerPassword').addClass('is-invalid');
                  }
                }
                _context7.next = 20;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7['catch'](7);

                app.isLoading = false;

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[7, 17]]);
      }))();
    },


    /**
     * Add product add-on
     */
    _addProductAddon: function _addProductAddon(variantId, productTitle, productPrice, event) {
      var product = app.storeUtilities.productAddons.products.find(function (x) {
        return x.variants[0].id === variantId;
      });
      app.storeUtilities.productAddons.totalValue += parseFloat(product.variants[0].price) * 100;
      product.selected = true;
      product.labelFinal = productTitle + ' Price: ' + app._formatMoney(productPrice);
      $('#selectedChain').html('' + product.labelFinal);
    },


    /**
     * Remove product add-on
     */
    _removeProductAddon: function _removeProductAddon(variantId, event) {
      var product = app.storeUtilities.productAddons.products.find(function (x) {
        return x.variants[0].id === variantId;
      });
      app.storeUtilities.productAddons.totalValue -= parseFloat(product.variants[0].price) * 100;
      product.selected = false;
    },


    /**
     * Promo products URL enabled codes
     */
    _setPromosEnablerCodes: function _setPromosEnablerCodes() {
      var storedEnablerCodes = JSON.parse(sessionStorage.getItem('cart_promos_enabler_codes')) || [];
      var newUserCode = app._getUrlParameter('promo_code');
      var storedUserCode = storedEnablerCodes.find(function (code) {
        return code === newUserCode;
      });

      // push the user code from the url to the array in the session only if it doesn't exists
      if (newUserCode && !storedUserCode) {
        storedEnablerCodes.push(newUserCode);
        sessionStorage.setItem('cart_promos_enabler_codes', JSON.stringify(storedEnablerCodes));
      }
      // set the final codes
      app.storeUtilities.cartPromos.enablerCodes = storedEnablerCodes;
    },
    _getUpsellMessage: function _getUpsellMessage(upsellMessage, qualifierAmount) {
      var cartTotal = parseFloat(app.cart.total_price / 100);
      var remainingAmount = Math.abs((cartTotal - parseFloat(qualifierAmount)) * 100);
      var remainingAmountMoney = app._formatMoney(remainingAmount);

      if (upsellMessage.indexOf('{amount}') >= 0) {
        upsellMessage = upsellMessage.split('{amount}');
        upsellMessage = upsellMessage[0] + ' ' + remainingAmountMoney + ' ' + upsellMessage[1];
      }

      return upsellMessage;
    },


    /**
     * Check if cart promo product is qualified for the cart
     */
    _checkPromoQualification: function _checkPromoQualification(product) {
      var cartItems = app.cart.items;
      var discountCode = app.storeUtilities.cartPromos.settings.discountCode;
      var qualifierType = product.settings.qualifierType;
      var qualifierAmount = product.settings.minimumCartAmount * 100;
      var isPromoInCart = cartItems.findIndex(function (x) {
        return x.product_id === product.data.id;
      }); // search if promo exists in cart items

      if (isPromoInCart >= 0) {
        // promo exists in cart => make the following checks
        product.inCart = true;
        // we need this to pass the discount code at the checkout URL
        // alters the cart form URL on the fly
        var currentFormAction = $(app.selectors.cartForm).attr('action');
        var delimiter = '?';

        if (currentFormAction && currentFormAction.indexOf('?') !== -1) {
          delimiter = '&';
        }

        $(app.selectors.cartForm).attr('action', '' + currentFormAction + delimiter + 'discount=' + discountCode);
      } else {
        product.inCart = false;
      }

      // check qualification rules
      if (qualifierType === 'minimum cart amount') {
        product.visible = false;

        if (app.cart.total_price >= qualifierAmount) {
          // qualifier rules are valid
          product.qualified = true;
          app._checkPromoEnablerCode(product);
        } else {
          // qualifier rules are invalid
          product.qualified = false;

          if (product.settings.enableUpsell) {
            app._checkPromoEnablerCode(product);
          } else {
            product.visible = false;
          }

          // qualifier rules no longer valid for a promo => remove it from cart
          if (isPromoInCart >= 0) {
            app._removePromoFromCart(product.data.id);
          }
        }
      } else {
        product.qualified = true;
        app._checkPromoEnablerCode(product);
      }
    },
    _checkPromoEnablerCode: function _checkPromoEnablerCode(product) {
      var productId = product.data.id;
      var variantId = product.data.variants[0].id;
      var addMode = product.settings.addMode;
      var cartItems = app.cart.items;
      var promoUrlEnablerCode = product.settings.urlEnablerCode;
      var matchedPromoCode = app.storeUtilities.cartPromos.enablerCodes.find(function (code) {
        return code === promoUrlEnablerCode;
      });

      // enable with URL code (param) logic
      if (promoUrlEnablerCode) {
        product.visible = false;

        if (matchedPromoCode) {
          if (product.settings.addMode === 'auto' && product.qualified && cartItems.length > 0) {
            app._addPromoToCart(productId, variantId, addMode);
          } else {
            product.visible = true;
          }
        }
      } else if (product.settings.addMode === 'auto' && product.qualified && cartItems.length > 0) {
        app._addPromoToCart(productId, variantId, addMode);
      } else {
        product.visible = true;
      }
    },
    _checkCartForOrphanedPromos: function _checkCartForOrphanedPromos() {
      // get all promos in cart
      var promosInCart = app.cart.items.filter(function (x) {
        return x.properties.promo_product === 'true';
      });

      // If all cart items are only promo products then we have orphaned promo products in the cart
      // We need to remove these from the cart => No cheating ;-)
      if (app.cart.item_count > 0 && app.cart.item_count === promosInCart.length) {
        // empty the cart!
        app._clearPromosFromCart();
      }
    },
    _addPromoToCart: function _addPromoToCart(productId, variantId, addMode) {
      if (app.currentTemplate !== 'cart') {
        return;
      }

      var product = app.cart.items.find(function (item) {
        return item.product_id === productId;
      });

      // add promo product to cart only if it's not already there
      if (!product) {
        app.isLoading = true;

        axios.post('/cart/add.js', {
          quantity: 1,
          id: variantId,
          properties: {
            promo_product: 'true',
            add_mode: addMode
          }
        }).then(function (response) {
          app.isLoading = false;

          if (!app.isCartAjaxed) {
            location.reload();
          } else {
            app._getCartData();
            app.$snotify.success('Gift added to cart. A discount estimate has been applied.', 'Free Gift', {
              timeout: 10000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              buttons: [{
                text: 'Close',
                bold: true,
                closeOnClick: true
              }]
            });
          }
          return response;
        }).catch(function (error) {
          console.log(error);
          throw error;
        });
      }
    },
    _removePromoFromCart: function _removePromoFromCart(productId) {
      if (app.currentTemplate !== 'cart') {
        return;
      }

      var cartItemIndex = app.cart.items.findIndex(function (item) {
        return item.product_id === productId;
      }) + 1;
      app.isLoading = true;

      axios.post('/cart/change.js', {
        quantity: 0,
        line: cartItemIndex
      }).then(function (response) {
        app.isLoading = false;

        if (!app.isCartAjaxed) {
          location.reload();
        } else {
          app._getCartData();
          app.$snotify.info('Gift removed from cart.', 'Free Gift', {
            timeout: 10000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
            }]
          });
        }
        return response;
      }).catch(function (error) {
        console.log(error);
        throw error;
      });
    },
    _clearPromosFromCart: function _clearPromosFromCart(itemCount) {
      app.isLoading = true;
      var title = void 0;
      var body = void 0;

      if (app.cart.item_count > 1) {
        title = 'Free Gifts';
        body = 'Gifts removed from cart.';
      } else {
        title = 'Free Gift';
        body = 'Gift removed from cart.';
      }

      axios.post('/cart/clear.js').then(function (response) {
        app.isLoading = false;

        if (!app.isCartAjaxed && app.currentTemplate === 'cart') {
          location.reload();
        } else {
          app._getCartData();

          if (app.currentTemplate !== 'cart') {
            app._toggleCartDrawer();
          }

          app.$snotify.info(body, title, {
            timeout: 10000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
            }]
          });
        }
        return response;
      }).catch(function (error) {
        console.log(error);
        throw error;
      });
    }
  }
};

export default storeUtilitiesMethods;